import { useQuery } from "@tanstack/react-query";
import { getProductById } from "../api/endpoints";
import { qk } from "../api/queryKeys";

export default function useProduct(productId) {
  return useQuery({
    queryKey: qk.products.detail(productId),
    queryFn: ({ signal }) => getProductById(productId, { signal }),
    enabled: !!productId,
  });
}
